import { Injectable } from '@angular/core';
declare const SockJS: any;
declare const Stomp: any;
import { environment } from '../../../environments/environment';
import { CommonServiceService } from './../services/common-service/common-service.service';
import { LocalStorageService } from './../services/local-storage/local-storage.service';
@Injectable({
    providedIn: 'root',
})
export class MessageService {
    constructor(
        private commonServiceService: CommonServiceService,
        private localStorageService: LocalStorageService,
    ) {
        this.initializeWebSocketConnection();
    }
    public stompClient: any;
    private socket: any;
    public msg = [];
    private reconnectDelay = 1000;

    initializeWebSocketConnection() {
        const serverUrl = environment.socketUrl;
        console.log(serverUrl);
        // const ws = new SockJS(serverUrl);
        this.socket = new SockJS(serverUrl);
        this.stompClient = Stomp.over(this.socket);
        // eslint-disable-next-line
        const that = this;
        // tslint:disable-next-line:only-arrow-functions
        this.stompClient.connect({}, function (frame: any) {
            console.log('Connected:', frame);
            that.commonServiceService.setloadingAfterSocket(true);
            that.stompClient.subscribe('/message', (message: any) => {
                console.log(message);
                const gyanData = that.localStorageService.getItem('gyanData');
                const rootGyanId = that.localStorageService.getItem('rootGyanId');
                const msgBody = JSON.parse(message.body);
                if ((msgBody.dt === 1 || msgBody.dt === 9) && msgBody.id === gyanData?.gyanId) that.commonServiceService.setCallfromSocketArticleList(true);
                if (msgBody.dt === 2 && msgBody.id === gyanData?.gyanId) that.commonServiceService.setCallfromSocketArticleListSummary(true);
                if ((msgBody.dt === 3 || msgBody.dt === 5) && msgBody.id === gyanData?.gyanId) that.commonServiceService.setCallfromSocketForMDS(true);
                if (msgBody.dt === 100 && msgBody.id === rootGyanId) that.commonServiceService.setCallFromSocketForGyanStatus(msgBody);
                return message.body;
            });
        });

        // WebSocket close event to handle unexpected disconnections
        this.socket.onclose = function () {
            console.log('WebSocket disconnected');
            that.reconnect();
        };

        // WebSocket error event to handle unexpected errors
        this.socket.onerror = function (error: any) {
            console.error('WebSocket error:', error);
            that.reconnect();
        };
    }

    isConnected(): boolean {
        return this.stompClient && this.stompClient.connected;
    }

    sendMessage(message: any) {
        console.log('sendMessage');
        this.stompClient.send('/app/send/message', {}, message);
    }

    closeWebSocketConnection() {
        if (this.stompClient) {
            this.stompClient.disconnect(() => {
                console.log('WebSocket connection closed manually.');
            });
        }
        if (this.socket) {
            this.socket.close();
        }
    }

    reconnect() {
        console.log(`Attempting to reconnect in ${this.reconnectDelay / 1000} seconds`);
        setTimeout(() => {
            this.initializeWebSocketConnection();
        }, this.reconnectDelay);
    }
}
